import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";

import CssBaseline from "@mui/material/CssBaseline";
import SearchBox from "../common/components/SearchBox";
import {
  Typography,
  Box,
  Button,
  Menu,
  MenuItem,
  IconButton,
  Badge,
  Divider,
  TextField,
  Tooltip,
} from "@mui/material";
import { connect } from "react-redux";
import { CardContent, Toolbar } from "@mui/material";
import { useHistory } from "react-router-dom";

import { Tab, Tabs } from "@mui/material";
import { TabPanel, a11yProps } from "../common/components/TabPanel";
import PositionsDropdown from "./pages/PositionsDropdown";
import ScholarshipSettings from "./pages/ScholarshipSettings";
import RoleManagement from "./pages/RoleManagement";
import SupportDeskSettings from "./pages/SupportDeskSettings";
import ActingSignatories from "./pages/ActingSignatories";
import { useRequiredAuth } from "../common/guard/requiredAuth";

const GlobalSettings = (props) => {
  useEffect(() => {
    document.title = "TMIS | Global Settings";
  }, []);

  const { hasPermissions } = useRequiredAuth();

  const { user, loading, systemSettingPositions } = props;

  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className="px-4 pt-2">
      <div className="border rounded">
        <AppBar position="static" elevation={0} className="app-bar w-100">
          <Toolbar
            style={{
              minHeight: "0px",
              borderBottom: "3px solid #e9ecef",
            }}
            className=" my-0 py-1 bg-light"
          >
            <Typography
              variant="p"
              noWrap
              component="div"
              className="d-flex  align-items-center text-uppercase text-primary font-weight-bold"
            >
              <span className="text-dark ">Global Settings</span>
              <span className="material-icons" style={{ color: "#cecece" }}>
                chevron_right
              </span>

              <Tabs
                variant="scrollable"
                scrollButtons="auto"
                value={value}
                onChange={handleChange}
                aria-label="System Settings"
              >
                <Tab
                  className={`${
                    !hasPermissions(["GLOBAL_SETTINGS_POSITIONS"])
                      ? "d-none"
                      : ""
                  }`}
                  label={
                    <span className="d-inline-flex">
                      <span className="badge badge-secondary mr-1">
                        {systemSettingPositions.length}
                      </span>{" "}
                      Positions
                    </span>
                  }
                  {...a11yProps(0)}
                />

                <Tab
                  className={`${
                    !hasPermissions(["GLOBAL_SETTINGS_SCHOLARSHIPS"])
                      ? "d-none"
                      : ""
                  }`}
                  label="Scholarships"
                  {...a11yProps(1)}
                />
                <Tab
                  className={`${
                    !hasPermissions(["GLOBAL_SETTINGS_ROLES"]) ? "d-none" : ""
                  }`}
                  label="Roles"
                  {...a11yProps(2)}
                />
                <Tab
                  className={`${
                    !hasPermissions(["GLOBAL_SETTINGS_SUPPORT_DESK"])
                      ? "d-none"
                      : ""
                  }`}
                  label="Support Desk"
                  {...a11yProps(3)}
                />
                <Tab
                  className={`${
                    !hasPermissions(["GLOBAL_SETTINGS_SUPPORT_DESK"])
                      ? "d-none"
                      : ""
                  }`}
                  label="Acting Signatories"
                  {...a11yProps(4)}
                />
              </Tabs>
            </Typography>
          </Toolbar>
        </AppBar>

        <TabPanel value={value} index={0}>
          {hasPermissions(["GLOBAL_SETTINGS_POSITIONS"]) && (
            <PositionsDropdown />
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          {hasPermissions(["GLOBAL_SETTINGS_SCHOLARSHIPS"]) && (
            <ScholarshipSettings />
          )}
        </TabPanel>
        <TabPanel value={value} index={2}>
          {hasPermissions(["GLOBAL_SETTINGS_ROLES"]) && <RoleManagement />}
        </TabPanel>
        <TabPanel value={value} index={3}>
          {hasPermissions(["GLOBAL_SETTINGS_SUPPORT_DESK"]) && (
            <SupportDeskSettings />
          )}
        </TabPanel>
        <TabPanel value={value} index={4}>
          {hasPermissions(["GLOBAL_SETTINGS_SUPPORT_DESK"]) && (
            <ActingSignatories />
          )}
        </TabPanel>
      </div>
    </div>
  );
};

const mapStateToProps = ({ user, loading, systemSettingPositions }) => {
  return { user, loading, systemSettingPositions };
};

export default connect(mapStateToProps, {})(GlobalSettings);
